import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetCompanyTypesQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import CompanyTypeDeleteIconButton from './CompanyTypeDeleteIconButton';
import CreateCompanyTypeModal from './CompanyTypeCreateModal';
import CompanyTypeEditIconButton from './CompanyTypeEditIconButton';

const totalColumns = 3;

function CompanyTypesTable() {
  const {data, isLoading, isError, isSuccess} = useGetCompanyTypesQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateCompanyTypeModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="CompanyTypes Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>CompanyTypes</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Type</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="right">
                    <CompanyTypeEditIconButton companyType={row} />
                    <CompanyTypeDeleteIconButton companyTypeId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No Company Type found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch Company Types.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default CompanyTypesTable;
